import { render, staticRenderFns } from "./RoyaltyApportionment.vue?vue&type=template&id=399b0f16&scoped=true&"
import script from "./RoyaltyApportionment.vue?vue&type=script&lang=js&"
export * from "./RoyaltyApportionment.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyApportionment.vue?vue&type=style&index=0&id=399b0f16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b0f16",
  null
  
)

export default component.exports